import { render } from "./vendorProfileModel.vue?vue&type=template&id=82c33fd0&scoped=true"
import script from "./vendorProfileModel.vue?vue&type=script&lang=js"
export * from "./vendorProfileModel.vue?vue&type=script&lang=js"

import "./vendorProfileModel.vue?vue&type=style&index=0&id=82c33fd0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c33fd0"]])

export default __exports__